import {Button, Spinner} from "reactstrap";

import "./style.scss";

const SubmitButton = (
    {
        isLoading,
        icon,
        className = '',
        style = {},
        color = 'primary',
        onClick,
        id,
        children,
        isDisabled,
        title,
        actionName,
        type = "submit",
        outline = false,
        isLoadingOnlySpinner = false
    }) => {
    return (
        <Button
            type={type}
            disabled={isDisabled || isLoading}
            className={`${className} submit-button`}
            style={style}
            color={color}
            id={id}
            onClick={onClick}
            title={title}
            outline={outline}
        >
            {isLoading ?
                <div className="box-spinner">
                    <Spinner className={`reload-spinner${isLoadingOnlySpinner ? " m-0" : ""}`}/>
                    {!isLoadingOnlySpinner ?
                        <>
                            در حال {actionName || children}
                            {" "}
                        </>
                        : null
                    }
                </div>
                :
                <div className="d-flex justify-content-center align-items-center cstumbtnform ">
                    {icon && <div className="mr-1">{icon}</div>}
                    {children}
                </div>
            }
        </Button>
    );
}

export default SubmitButton;
